<template>
  <td>
    <div class="mobile-label">{{ label }}</div>
    <div :class="valueClasses">
      <slot></slot>
    </div>
  </td>
</template>
<script>
export default {
    name: "table-column",
    props: {
        customKey: {type: String, default: ''},
        field: {type: String, default: ''},
        label: {type: String, default: ''},
        small: {type: Boolean, default: false},
        sortable: {type: Boolean, default: false},
        tooltip: {type: String, default: ''}
    },
    data() {
        let myKey = this.customKey ? this.customKey : this.label;
        if (!myKey) {
            throw new Error("TableColumn must have a 'customKey' if 'label' is missing or not unique");
        }
        return {
            myKey: myKey
        }
    },
    beforeDestroy() {
        // find position of column in parent
        const index = this.$parent.myColumns.map(column => column.myKey).indexOf(this.myKey);

        // and delete
        if (index >= 0) {
            this.$parent.myColumns.splice(index, 1);
        }
    },
    beforeMount() {
        this.addRefToTable();
    },
    beforeUpdate() {
        this.addRefToTable();
    },
    computed: {
        valueClasses() {
            let classes = 'mobile-value';
            if (this.small) {
                classes += ' small';
            }
            return classes;
        }
    },
    methods: {
        addRefToTable() {
            if (!this.$parent.$data._isTable) {
                this.$destroy();
                throw new Error('You should wrap TableColumn with a MyTable');
            }

            // Don't add repeats to the table
            const found = this.$parent.myColumns.some(column => column.myKey === this.myKey);
            if (!found) {
                this.$parent.myColumns.push(this);
            }
        },
    },
}
</script>
